import { render, staticRenderFns } from "./TileComment.vue?vue&type=template&id=baf4118a"
import script from "./TileComment.vue?vue&type=script&lang=js"
export * from "./TileComment.vue?vue&type=script&lang=js"
import style0 from "./TileComment.vue?vue&type=style&index=0&id=baf4118a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports